module.exports = __webpack_public_path__ + "static/media/emma-roberts-win.b6234c64.jpg";